import React, { Component, useEffect,useRef, useState } from 'react';
import './multilevel.scss';
import services from 'src/api/service';
import useApi from 'src/hooks/useApi';

const AmcMultilevel = ({ onCampaignReceive, appliedCampaigns = [] }) => {
  const getCampaignData = useApi(services.postService);
  const [dropdownData, setDropdownData] = useState([]);
  const [clonedropdownData, setCloneDropdownData] = useState([]);
  const [selectedNames, setSelectedNames] = useState('');
  const [openMultiDropdown, setMultiDropdown] = useState(false);
  const [selectedInnerchild, setSelectedInnerchild] = useState();
  const [prevselectedInnerchild, setPrevselectedInnerchild] = useState();
  const [applyEnableDisable, setApplyEnableDisable] = useState(false);
  const [expandDropdown, setExpandDropdown] = useState('');
  const [noData, setNodata] = useState(false);
  const [isSearchData, setIsearchData] = useState(false);
  const [noCampaigns, setNocampaigns] = useState(false);
    useEffect(() => {
    campaignCall();
  }, []);
  const [prevSelectedNames, setPrevSelectedNames] = useState(appliedCampaigns.join(', '));

  useEffect(() => {
    setPrevSelectedNames(appliedCampaigns.join(', ')); 
  }, [appliedCampaigns]);

  useEffect(() => {
    setApplyEnableDisable(selectedNames !== prevSelectedNames && selectedNames.length > 0);
  }, [selectedNames, prevSelectedNames]);
   
 
  const campaignCall = async (data) => {
    let firstDate;
    let endDate;
    if (data) {
      firstDate = new Date(
        new Date(data.currentDay.toISOString().split('T')[0]).setDate(new Date(data.currentDay.toISOString().split('T')[0]).getDate() + 1)
      )
        .toISOString()
        .split('T')[0];
      endDate = new Date(
        new Date(data.endDay.toISOString().split('T')[0]).setDate(new Date(data.endDay.toISOString().split('T')[0]).getDate() + 1)
      )
        .toISOString()
        .split('T')[0];
    } else {
      firstDate = new Date(new Date().setDate(new Date().getDate() - ((new Date().getDay() + 6) % 7) - 14)).toISOString().split('T')[0];
      endDate = new Date(new Date().setDate(new Date().getDate() - ((new Date().getDay() + 7) % 14))).toISOString().split('T')[0];
    }
    getCampaignData.request({
      url: '/amc/pathCampaigns',
      nodeAPI: 1,
      payload: {}
    });
  };

  useEffect(() => {
    onCampaignReceive({
      name: 'ALL',
      campaign: [],
      loading: 'loading'
    });
    const { loading, data } = getCampaignData;
    if (!loading && data && data.success == true && data.message !== 'failed' && data.data) {
      let dropdownDatas = [
        {
          name: 'Select All',
          checked: true,
          display: true
        }
      ];
      Object.keys(data.data).forEach((val) => {
        let obj = {
          name: val,
          campaign: data.data[val].map((camp) => {
            return {
              name: camp,
              checked: true
            };
          }),
          checked: true,
          display: true
        };
        obj.campaign.unshift({ name: 'All', checked: true });
        dropdownDatas.push(obj);
      });
      onCampaignReceive({
        name: 'ALL',
        campaign: [],
        loading: 'completed'
      });
      setDropdownData(dropdownDatas);
      setCloneDropdownData(global.structuredClone(dropdownDatas));
      sessionStorage.setItem('innerChild', '') 
    } else if (!loading && data && data.success == true &&  (data.message === 'failed' || data.data.length === 0)) {
      setNocampaigns(true);
      onCampaignReceive({
        name: 'ALL',
        campaign: [],
        loading: 'completed'
      });
      sessionStorage.setItem('innerChild', '') 
     }
  }, [getCampaignData.loading]);

  const handleChange = (e, checked, i, j, name) => {
    let dropdown = [...dropdownData];
    let selectedName = dropdown[i].campaign[j].name;
    let names = [];
  
    if (name === 'only') {
        dropdown.forEach((val, k) => {
            if (k === i) {
                val.checked = true; 
                val.campaign.forEach((obj, idx) => {
                    obj.checked = idx === j; 
                });
            } else {
                val.checked = false; 
                if (val.campaign) {
                    val.campaign.forEach((obj) => {
                        obj.checked = false; 
                    });
                }
            }
        });
        setDropdownData(dropdown);
        setSelectedNames(selectedName);
        setApplyEnableDisable(true);
        setSelectedInnerchild(i);
        return;
    }
    checked = !checked;
    dropdown.forEach((val,k)=> {
      if(k !== i) {
        val.checked = false;
        if(val.campaign) {
          val.campaign.forEach((obj) => {
            obj.checked = false
          });
        }
      }
    })
    if(selectedName === 'All') {
      dropdown[i].campaign.forEach((val)=>{
        val.checked = checked;
        if(checked && val.name !== 'All') {
          names.push(val.name)
        }
      });
    }
    else {
      dropdown[i].campaign[j].checked = checked;
      names = (dropdown[i].campaign.filter((val)=> val.checked).map((data)=> data.name).filter((obj)=> obj !== 'All'));
      if(names.length === dropdown[i].campaign.length - 1){
        dropdown[i].campaign[0].checked = true;
      }
      else {
        dropdown[i].campaign[0].checked = false;
      }
    }
    dropdown[i].checked = names.length === 0 ? false : true;
    setPrevselectedInnerchild(selectedInnerchild);
    setSelectedInnerchild(names.length > 0 ? i : '');
    setSelectedNames(names.join(', '));
    setDropdownData(dropdown);
  };

  const confirmCampaigns = (e) => {
    let data = {};
    if (e === 'all') {
      onCampaignReceive({
        name: 'ALL',
        campaign: []
      });
      setSelectedInnerchild('')
      setMultiDropdown(false);
      return;
    }
    let index = selectedInnerchild === '' ? 0 : selectedInnerchild;
    let filterData = dropdownData[index].campaign ? dropdownData[index].campaign.filter((val) => val.checked && val.name !== 'All') : [];
    data['campaigns'] = filterData.map((val) => val.name);
    data['name'] = data['campaigns'].length === 0 ? 'ALL' : dropdownData[index].name;

    setPrevSelectedNames(data.campaigns.join(', ')); // set applied selected names
    setPrevselectedInnerchild(selectedInnerchild);
    sessionStorage.setItem('innerChild', selectedInnerchild);
    setSelectedInnerchild('');
    setMultiDropdown(false);
    onCampaignReceive(data);

    let updatedDropdownData = [...clonedropdownData];
    const findMatchingItem = (item, dropdownData) => {
      return dropdownData.some((dropdownItem) => {
        if (dropdownItem.name === item.name) {
          if (item.campaign && dropdownItem.campaign) {
            return item.campaign.every((subItem) =>
              dropdownItem.campaign.some(
                (dropdownSubItem) => dropdownSubItem.name === subItem.name
              )
            );
          }
          return true;
        }
        return false;
      });
    };

    updatedDropdownData.forEach((val) => {
      if (findMatchingItem(val, dropdownData)) {
        val.checked = true;
        if (val.campaign) {
          val.campaign.forEach((obj) => {
            obj.checked = dropdownData[0].campaign && dropdownData[0].campaign.some(
              (dropdownSubItem) => dropdownSubItem.name === obj.name
            );
          });
        }
      } else {
        val.checked = false;
        if (val.campaign) {
          val.campaign.forEach((obj) => {
            obj.checked = false;
          });
        }
      }
    });
    if(isSearchData){
      setDropdownData(updatedDropdownData);
      setCloneDropdownData(updatedDropdownData)
    }
  };


  const cancelSelection = () => {
    let index = selectedInnerchild;
    let dropdown = dropdownData.length > 0 ? [...dropdownData] : [...clonedropdownData];
    if(index === '') {
      dropdown.forEach((val)=>{
        val.checked = false;
        if(val.campaign) {
          val['campaign'].forEach((obj) => {
            obj.checked = false;
          });
        }
      })
    }
   else if(index){
    dropdown[index].checked = !dropdown[index].checked;
    if(dropdown[index]['campaign']) {
      dropdown[index]['campaign'].forEach((val) => {
        val.checked = false;
      });
    }
   }
    
    if(!prevselectedInnerchild || prevselectedInnerchild === '' || prevselectedInnerchild === 0) {
      dropdown.forEach((val) => {
        val.checked = true; 
        if(val.campaign) {
          val.campaign.forEach((obj)=> {
            obj.checked = true;
          })
        }
      });
      setSelectedNames('');
    }
    else if(prevselectedInnerchild && prevselectedInnerchild !== 'null'){
      dropdown[prevselectedInnerchild].checked = true;
      dropdown[prevselectedInnerchild]?.campaign?.forEach((obj)=> {
        obj.checked = true;
      });
      setSelectedNames(dropdown[prevselectedInnerchild].campaign.map(val=> val.name).filter((data)=> data !== 'All').join(', '));
    };
    //setSelectedInnerchild(prevselectedInnerchild);
    //(clonedropdownData);
    let parentLevel = !openMultiDropdown;
    setMultiDropdown(parentLevel);
   };

  const searchData = (e) => {
    let data = [...clonedropdownData];
    let filterData = e === '' ? data : data.filter((val) => val.name.toLowerCase().includes(e.toLowerCase()));
    if(filterData.length > 0 ) {
      setIsearchData(true);
      setNodata(false);
      setDropdownData(filterData);
    } else {
      setNodata(true);
      setIsearchData(false);
    }
  };

  const openMultilevel = (e) => {
    if (e.target.getAttribute('name') === 'parent') {
      let parentLevel = !openMultiDropdown;
      setMultiDropdown(parentLevel);
      if (!parentLevel) {
        sessionStorage.setItem('innerChild', selectedInnerchild) 
        document.getElementById('category_search').value = '';
        //setDropdownData(clonedropdownData);
      }
      else {
        let id = sessionStorage.getItem('innerChild');
        setPrevselectedInnerchild(id)
        setSelectedInnerchild(id);

      }
    }
    e.preventDefault();
  };

  const clickParent = (e, i) => {
    let clickedName = e.target.getAttribute('name');
    if (clickedName === 'child' || clickedName === 'child-input') {
      let index = i === selectedInnerchild ? '' : i;
      let previousSelected = selectedInnerchild;
      let data = [...dropdownData]; 
      setPrevselectedInnerchild(selectedInnerchild);
      setSelectedInnerchild(index);
      if (clickedName === 'child') {
        setExpandDropdown(index);
      }
      if (clickedName === 'child-input') {
        if(previousSelected && previousSelected !== 'null' && previousSelected !== i && previousSelected !== '') {
          data[previousSelected].checked = false;
          data[previousSelected].campaign?.forEach((val)=>{
            val.checked = false;
          })
        }
        if (i === 0) {
          data.forEach((val, i) => {
            val.checked = i === 0 ? !val.checked : data[0].checked;
            if (val.campaign && val.campaign.length > 0) {
              val.campaign.forEach((obj) => {
                obj.checked = data[0].checked;
              });
            }
          });
        } else {
          data[0].checked = false;
          data.forEach((val, j) => {
            if (j === i) {
              val.checked = !val.checked;
              const newChecked = val.checked; 
              // val.campaign.forEach((obj) => {
              //   obj.checked = !obj.checked;
              // });
              val.campaign = val.campaign.map((obj) => ({
                ...obj,
                checked: newChecked
              }));
            }
            else {
              val.checked = false;
              if(val.campaign) {
                val.campaign.forEach((obj) => {
                  obj.checked = false;
                });
              }
            }
          });
          let allStatus = data.filter((j) => j.checked).length === data.length - 1;
          data[0].checked = allStatus;
        }
        let checkedItems = data.filter((val) => val.checked);
        let innerChildIndex = data.findIndex((val) => val.checked);
        setPrevselectedInnerchild(selectedInnerchild);
        setSelectedInnerchild(checkedItems.length > 1 ? '' : innerChildIndex === -1 ? '' : innerChildIndex);
        setApplyEnableDisable(checkedItems.length > 0 ? true : false);
        setSelectedNames(
          checkedItems.length == 0
            ? ''
            : checkedItems.length > 1
            ? 'All'
            : checkedItems[0].campaign
                .map((val) => val.name)
                .filter((data) => data !== 'All')
                .join(', ')
        );
        setDropdownData(data);
      }
    }
  };
  

  const wrapperRefFilter = useRef("multilevelFilter");
  useClickOutside(wrapperRefFilter, () => { 
    // if(!noCampaigns) {
    //   cancelSelection();
    // }
    setMultiDropdown(false);
    //setDropdownData(dropdownData);
  });

  function useClickOutside(ref, onClickOutside) {
    useEffect(() => { 
      function handleClickOutside(event) {
        if (event.target.getAttribute('alt') !== 'multilevel' &&  ref.current && typeof(ref.current) !== 'string' && !ref.current.contains(event.target)) {
          onClickOutside();
        }
      } 
      document.addEventListener("mousedown", handleClickOutside);
      return () => {
        document.removeEventListener("mousedown", handleClickOutside);
      };
    }, [ref, onClickOutside]);
  }

  useEffect(() => {
    if (openMultiDropdown) {
      document.body.classList.add('overflow-hidden');
    } else {
      document.body.classList.remove('overflow-hidden');
    }
  }, [openMultiDropdown]);


  // onMouseLeave={(e) => {clearData()}}
  return (
    <>
      {!getCampaignData.loading && (
        <div alt='multilevel' ref={wrapperRefFilter}  className="ptc-multilevel">
          <ul alt='multilevel' className="multilevel-dropdown-menu">
            <li alt='multilevel' className="parent" name="parent" onClick={(e) => openMultilevel(e)} title={selectedNames === '' ? 'All' : selectedNames}>
              <a  alt='multilevel' href="#" name="parent">
                Campaigns -<em alt='multilevel' name="parent">{selectedNames === '' ? 'All' : selectedNames}</em>{' '}
                <svg alt='multilevel' name="parent" xmlns="http://www.w3.org/2000/svg" width="16" height="14" viewBox="0 0 16 14" fill="none">
                  <path
                    d="M14.6666 1H1.33325L6.66658 7.30667V11.6667L9.33325 13V7.30667L14.6666 1Z"
                    stroke="#1877F2"
                    stroke-width="1.60714"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </a>
              {openMultiDropdown && (
                <ul alt='multilevel' className="child" style={{ paddingLeft: '10px' }}>
                  <li alt='multilevel'>
                    <svg alt='multilevel'
                      className="feather feather-search"
                      fill="none"
                      height="24"
                      stroke="white"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      viewBox="0 0 24 24"
                      width="24"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <circle cx="11" cy="11" r="8" />
                      <line x1="21" x2="16.65" y1="21" y2="16.65" />
                    </svg>
                    <input alt='multilevel'
                      autoComplete='off'
                      className="searchFiled searchColor"
                      id="category_search"
                      type="text"
                      disabled={noCampaigns}
                      placeholder="Search category"
                      onChange={(e) => searchData(e.target.value)}
                    />
                  </li>
                  {/* <li name='All' style={{paddingLeft: '15px'}} onClick={(e) => clickAll(e)}>All</li> */}
                  {dropdownData.length > 0 && !noData &&
                    dropdownData.map((val, i) => {
                      let checkmarkClass = i === expandDropdown && val.name !== 'Select All' ? 'checkmark minus-mark' : 'checkmark';
                      return (
                        <>
                          {val.display && <li
                            className="parent"
                            disabled={expandDropdown === 0}
                            title={val.name}
                            name="child-input"
                            onClick={(e) => clickParent(e, i)}
                          >
                            <div alt='multilevel' className="position-absolute check-box-align">
                              <input autoComplete='off' alt='multilevel' type="checkbox" name="child-input" checked={val.checked} onChange={(e) => clickParent(e, i)}/>
                              <span alt='multilevel' name="child-input" className={checkmarkClass}></span>
                            </div>
                            <a alt='multilevel' href="#" name="child" title={val.name}>
                              <em alt='multilevel' className="truncateName" title={val.name} name="child">
                                {val.name}
                              </em>
                              {val.name !== 'Select All' && (
                                <span alt='multilevel' className="expand" style={{ transform: i === expandDropdown ? 'rotate(-180deg)' : '' }} name="child">
                                  <svg alt='multilevel' xmlns="http://www.w3.org/2000/svg" name="child" width="10" height="7" viewBox="0 0 10 7" fill="none">
                                    <path
                                      name="child"
                                      d="M1.175 0.150879L5 3.97588L8.825 0.150879L10 1.33421L5 6.33421L0 1.33421L1.175 0.150879Z"
                                      fill="#8F8F91"
                                    />
                                  </svg>
                                </span>
                              )}
                            </a>
                            {/* {val.name !== 'Select All' && expandDropdown === i && (
                              <ul alt='multilevel' className="child inner-child">
                                {val.campaign.map((obj, j) => {
                                  return (
                                    <>
                                      <li alt='multilevel' title={obj.name} onClick={(e) => handleChange(e, obj.checked, i, j, val.name)}>
                                        <input alt='multilevel' type="checkbox" checked={obj.checked} />
                                        <span alt='multilevel' className="checkmark"></span>
                                        <em alt='multilevel'>{obj.name}</em>
                                      </li>
                                    </>
                                  );
                                })}
                              </ul>
                            )} */}
                            {val.name !== 'Select All' && expandDropdown === i && (
                                <ul alt='multilevel' className="child inner-child">
                                   {/* <li title="All" onClick={(e) => handleChange(e, 'all')}>
                                  {' '}
                                  <input type="checkbox" checked={selectAll && selectedCampaign === i+'_index'}/>
                                  <span class="checkmark"></span>
                                  <em>All</em>
                                </li> */}
                                  {val.campaign.map((obj, j) => {
                                    return (
                                      <li key={j} alt='multilevel'  title={obj.name} className="campaign-item">
                                        <span alt='multilevel'  title={obj.name} onClick={(e) => handleChange(e, obj.checked, i, j, val.name)}
                                        >
                                          <input autoComplete='off' alt='multilevel'  type="checkbox"  checked={obj.checked} 
                                          />
                                          <span alt='multilevel' className="checkmark"></span>
                                          <em alt='multilevel'>{obj.name}</em>
                                        </span>
                                        {obj.name !== 'All' && (
                                          <span 
                                            alt='multilevel'  className="showOnhoverDrop"  onClick={(e) => handleChange(e, true, i, j, 'only')}
                                          >
                                            Only
                                          </span>
                                        )}
                                      </li>
                                    );
                                  })}
                                </ul>
                              )}

                          </li>}
                        </>
                      );
                    })}
                  {(noData || noCampaigns) && <p>No data found...</p>}
                </ul>
              )}
              {openMultiDropdown && (
                <p alt='multilevel' className="btn-cancel-apply">
                  <button alt='multilevel' type="button" className={`campaign-confirm ${!applyEnableDisable || noCampaigns ? 'disabled' : ''}`} onClick={(e) => confirmCampaigns()}>
                    Apply
                  </button>
                  <button alt='multilevel' type="button" className="campaign-cancel" disabled={noCampaigns} onClick={(e) => setMultiDropdown(false)}>
                    Cancel
                  </button>
                </p>
              )}
            </li>
          </ul>
        </div>
      )}
    </>
  );
};

export default AmcMultilevel;
